// Invoice pay links in USD and MXN. Mirrors pay_links() in
// backend/invoice_currency.py: MXN needs a multi-currency property, an
// exchange rate on the invoice and our own durable /pay URL. Pure, no React.

export const mxnPayUrl = (invoice, multiCurrency) => {
  const url = invoice && invoice.stripe_payment_url;
  const rate = Number(invoice && invoice.exchange_rate);
  if (!multiCurrency || !url || !(rate > 0) || !invoice.id) return null;
  let parsed;
  try { parsed = new URL(url); } catch (e) { return null; }
  if (!parsed.pathname.endsWith(`/api/invoices/${invoice.id}/pay`)) return null;
  parsed.searchParams.set('currency', 'MXN');
  return parsed.toString();
};

export const mxnTotal = (invoice) => {
  const rate = Number(invoice && invoice.exchange_rate);
  if (!(rate > 0)) return null;
  return Math.round(Number(invoice.total || 0) * rate * 100) / 100;
};
